import React, {useState} from "react"
import "./settings.css"
import {useSidebar} from "../../components/ui/sidebar"
// import ChangeProfilePicture from "./change_profile.js";
import {useTranslation} from "react-i18next"
import {Sparkles} from "lucide-react"
import {Button} from "../../components/ui/button"
import {Input} from "../../components/ui/input"
import {Label} from "../../components/ui/label"
import {Avatar, AvatarFallback, AvatarImage} from "../../components/ui/avatar"
import PageHeader from "../../components/Page/page_header";

export default function Profile({ defaultValues }) {
    // Translation hook to support multiple languages
    const {t} = useTranslation()
    // Get the current brand value from the app context
    const {brand} = useSidebar()
    // State to manage whether the Change Profile Picture modal is open or closed
    const [isChangeProfileOpen, setChangeProfileOpen] = useState(false)
    // Function to fetch the brand logo based on the brand name
    const fetchBrand = (brandName) => {
        return `${process.env.PUBLIC_URL}/Logos/${brandName}.png`;
}
    return (
        <div className={"default_page_style mt-12 justify-center align-center"}>
        <div className="w-full max-w-2xl mx-auto space-y-8 p-6 bg-white/50 dark:bg-zinc-950/50 backdrop-blur-xs rounded-xl border border-zinc-200/80 dark:border-zinc-800/80 shadow-xs">
            <PageHeader title="Profile" />
            <div className="flex items-center justify-center gap-6">
                <Avatar className="h-24 w-24 rounded-full border-2 border-zinc-200/80 dark:border-zinc-800/80 shadow-xs">
                    <AvatarImage
                        src={fetchBrand(brand)}
                        className="rounded-full object-cover"
                    />
                    <AvatarFallback className="bg-[#b19cd9] dark:bg-zinc-900 text-white font-medium text-lg text-center">
                        {brand}
                    </AvatarFallback>
                </Avatar>
                <Button
                    variant="outline"
                    className="h-24 w-24 rounded-full border-2 border-dashed border-zinc-200/80 dark:border-zinc-800/80
                             hover:border-zinc-300 dark:hover:border-zinc-700 hover:bg-zinc-50 dark:hover:bg-zinc-900/50
                             transition-colors shadow-sm"
                >
                    <Sparkles className="h-6 w-6 text-zinc-600 dark:text-zinc-400" />
                </Button>
            </div>
            <p className="text-zinc-700 dark:text-zinc-300 w-full text-center text-sm">
                Upload a new avatar
            </p>

            <div className="grid gap-6">
                <div className="grid gap-2">
                    <Label htmlFor="name" className="text-zinc-700 dark:text-zinc-300">
                        Display Name
                    </Label>
                    <Input
                        id="name"
                        // placeholder="Your brand name"
                        defaultValue={brand}
                        autoComplete="off"
                        className="bg-white dark:bg-zinc-900/50 border-zinc-200/80 dark:border-zinc-800/80
                                 focus:border-zinc-300 dark:focus:border-zinc-700
                                 focus:ring-1 focus:ring-zinc-200 dark:focus:ring-zinc-800
                                 placeholder:text-zinc-400 dark:placeholder:text-zinc-600 text-black"
                    />
                </div>

                {/*<div className="grid gap-2">*/}
                {/*    <Label*/}
                {/*        htmlFor="username"*/}
                {/*        className="text-zinc-700 dark:text-zinc-300"*/}
                {/*    >*/}
                {/*        Username*/}
                {/*    </Label>*/}
                {/*    <Input*/}
                {/*        id="username"*/}
                {/*        placeholder="@username"*/}
                {/*        defaultValue={defaultValues?.username}*/}
                {/*        autoComplete="off"*/}
                {/*        className="bg-white dark:bg-zinc-900/50 border-zinc-200/80 dark:border-zinc-800/80*/}
                {/*                 focus:border-zinc-300 dark:focus:border-zinc-700*/}
                {/*                 focus:ring-1 focus:ring-zinc-200 dark:focus:ring-zinc-800*/}
                {/*                 placeholder:text-zinc-400 dark:placeholder:text-zinc-600"*/}
                {/*    />*/}
                {/*</div>*/}


            </div>
            <div className="flex justify-end gap-4">
                <Button
                    variant="outline"
                    className="border-zinc-200/80 dark:border-zinc-800/80 hover:bg-zinc-50 dark:hover:bg-zinc-900/50 text-black "
                >
                    Cancel
                </Button>
                <Button className="bg-zinc-900 dark:bg-zinc-100 text-white dark:text-zinc-900 hover:bg-zinc-800 dark:hover:bg-zinc-200">
                    Save Changes
                </Button>
            </div>
        </div>
        </div>
    )
}
